import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Bed, ExternalLink } from 'lucide-react';

const AccommodationSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const accommodations = [
  {
    name: 'Hotel J. Balmes Vic',
    url: 'https://www.google.com/search?q=Hotel+J.+Balmes+Vic',
    testId: 'hotel-balmes'
  },
  {
    name: 'Hostal Montserrat',
    url: 'https://www.google.com/search?q=Hostal+Montserrat+Vic',
    testId: 'hostal-montserrat'
  },
  {
    name: 'Hotel Can Pamplona',
    url: 'https://www.google.com/search?q=Hotel+Can+Pamplona+Vic',
    testId: 'hotel-pamplona'
  }];


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 25 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut' }
    }
  };

  return (
    <section
      ref={ref}
      className="py-16 md:py-20 px-6 bg-gradient-to-b from-[#F9F7F2] to-[#F5F0EB]"
      data-testid="accommodation-section">

      <motion.div
        className="max-w-2xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}>

        {/* Section Title */}
        <motion.div className="text-center mb-10 md:mb-12" variants={itemVariants}>
          <span className="font-accent text-2xl md:text-3xl text-[#CCA598]">Donde descansar</span>
          <h2 className="font-heading text-3xl md:text-4xl text-[#5D4037] mt-1">
            Alojamiento
          </h2>
          <p className="font-body max-w-md !text-sm mt-3 mx-auto text-[#8D6E63]">Para que podáis disfrutar del fin de semana con total comodidad os dejamos algunas recomendaciones de alojamientos cercanos

          </p>
        </motion.div>

        {/* Icon */}
        <motion.div
          className="flex justify-center mb-8"
          variants={itemVariants}>

          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-[#CCA598]/20 to-[#D7CCC8]/30 shadow-sm">
            <Bed className="w-6 h-6 text-[#8D6E63]" strokeWidth={1.5} />
          </div>
        </motion.div>

        {/* Accommodation Links */}
        <motion.div
          className="space-y-3"
          variants={containerVariants}>

          {accommodations.map((hotel, index) =>
          <motion.a
            key={index}
            href={hotel.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center justify-between p-4 bg-[#F9F7F2] hover:bg-[#CCA598]/10 transition-all duration-300 border border-[#D7CCC8]/50 hover:border-[#CCA598]"
            variants={itemVariants}
            data-testid={hotel.testId}>

              <span className="font-heading text-lg text-[#5D4037] group-hover:text-[#3E2723]">
                {hotel.name}
              </span>
              <ExternalLink className="w-4 h-4 text-[#8D6E63] group-hover:text-[#5D4037] transition-colors" />
            </motion.a>
          )}
        </motion.div>
      </motion.div>
    </section>);

};

export default AccommodationSection;